import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CryptoJS from 'crypto-js';

const SignupRedirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hostname = window.location.hostname;

    // 🎯 Configuration par domaine
    const CAMPAIGNS = {
      'mesbonsplans.klesia.fr': {
        klesia: { entreprise: 'Klesia Campagne Marketing', siret: '000' },
      },
      'mesbonsplans.carcept-prev.fr': {
        carcept: { entreprise: 'Klesia Campagne Marketing Carcept', siret: '000' },
      },
      'mesbonsplans.klesiamut.fr': {
        klesiamut: { entreprise: 'Klesia Campagne Marketing Mut', siret: '000' },
      },
      'mesbonsplansghr.hapluspme.com': {
        ghr: { entreprise: 'Mes bons Plans GHR', siret: '000' },
      },
      'localhost': {
        carcept: { entreprise: 'Carcept local', siret: '000LOCAL' },
        klesia: { entreprise: 'Klesia local', siret: '001LOCAL' },
        klesiamut: { entreprise: 'Mut local', siret: '002LOCAL' },
        ghr: { entreprise: 'GHR local', siret: '003LOCAL' },
        }

    };

    const domainCampaigns = CAMPAIGNS[hostname];
    const entry = domainCampaigns?.[slug];

    if (entry) {
      const encrypt = (text) =>
        encodeURIComponent(CryptoJS.AES.encrypt(text, 'secret key 123').toString());

      const encryptedEntreprise = encrypt(entry.entreprise);
      const encryptedSiret = encrypt(entry.siret);

      navigate(`/signup/${encryptedEntreprise}/${encryptedSiret}`, { replace: true });
    } else {
      navigate('/error');
    }
  }, [slug, navigate]);

  return null;
};

export default SignupRedirect;